import { useRequest } from 'ahooks';
import { MicroServiceRepository } from 'repositories/MicroServiceRepository';

const repository = MicroServiceRepository;
export const useMicroService = () => {
  const getCourseData = useRequest(repository.getCourseData, { manual: true });

  return { getCourseData };
};